import React from "react"
import classNames from "classnames"

import i18nCommonData from "@/locales/zh-CN.json"
import Input from "../Input"
import InputAccount from "../InputAccount"

import styles from "./index.module.less"

const InputSmsCode: React.FC<{
    account: string
    smsCode: string
    smsCountDown: number
    setSmsCode: React.Dispatch<React.SetStateAction<string>>
    setAccount: React.Dispatch<React.SetStateAction<string>>
    handleKeyUp: (e: React.KeyboardEvent<HTMLInputElement>) => void
    handleSendSmsCode: () => Promise<void>
}> = ({
    account,
    smsCode,
    smsCountDown,
    setSmsCode,
    setAccount,
    handleKeyUp,
    handleSendSmsCode,
}) => {
    return (
        <>
            <InputAccount
                scene="smsCode"
                account={account}
                setAccount={setAccount}
                handleKeyUp={handleKeyUp}
            />
            <div className={styles.smsCodeRow}>
                <Input
                    className={classNames("smsCode")}
                    value={smsCode}
                    onChange={(e) => setSmsCode(e.target.value.slice(0, 6))}
                    onKeyUp={handleKeyUp}
                    placeholder={i18nCommonData["login.placeholder.code"]}
                />
                <div
                    className={classNames(
                        styles.sendSms,
                        smsCountDown && styles.disabled
                    )}
                    onClick={handleSendSmsCode}
                >
                    <div className={styles.text}>
                        {smsCountDown
                            ? `${i18nCommonData["login.code.resend"]}(${smsCountDown})`
                            : i18nCommonData["login.code.send"]}
                    </div>
                </div>
            </div>
        </>
    )
}

export default InputSmsCode
